import React from "react"
import PropTypes from "prop-types"
import Select from "react-select"

import "react-select/dist/react-select.css"
import { withTheme } from "emotion-theming"

import { css } from "react-emotion"

const Dropdown = props => {
    const styles = css`
        overflow: visible !important;

        .Select-control {
            font-family: ${props.theme.fontFamily};
            font-size: ${props.theme.fontSize};
            background-color: ${props.theme.inputBackgroundColor} !important;
            border-radius: ${props.theme.elementBorderRadius} !important;
            border: ${props.theme.dividerThickness}px solid ${props.theme.outlineColor} !important;
            outline: none !important;
            color: ${props.theme.fontColor} !important;
        }

        .Select-control .Select-value {
            color: ${props.theme.fontColor} !important;
        }

        .Select-value-label {
            color: ${props.theme.fontColor} !important;
        }

        .Select {
            font-family: ${props.theme.fontFamily};
            font-size: ${props.theme.fontSize};
            color: ${props.theme.fontColor} !important;

            outline: none !important;
        }
        .Select-menu {
            font-family: ${props.theme.fontFamily};
            font-size: ${props.theme.fontSize};
            border: ${props.theme.dividerThickness}px solid ${props.theme.outlineColor} !important;
        }
        .Select-menu-outer {
            z-index: 3;
            background-color: ${props.theme.inputBackgroundColor} !important;
            font-family: ${props.theme.fontFamily};
            font-size: ${props.theme.fontSize};
            border: ${props.theme.dividerThickness}px solid ${props.theme.outlineColor} !important;
        }

        .Select-option {
            background-color: ${props.theme.inputBackgroundColor} !important;
            color: ${props.theme.fontColor} !important;
        }

        .Select-option.is-focused {
            background-color: ${props.theme.elementHighlightColor} !important;
            color: ${props.theme.fontColor} !important;
        }
    `

    var selectedOption = null
    if (props.value && props.options) {
        props.options.forEach(option => {
            if (option.value === props.value) selectedOption = option
        })
    }

    const onChange = option =>
        option ? props.onChange && props.onChange(option.value) : props.onChange && props.onChange()

    return (
        <Select
            {...props}
            className={styles}
            value={selectedOption}
            onChange={onChange}
            options={props.options}
            ignoreCase={true}
        />
    )
}

Dropdown.propTypes = {
    value: PropTypes.any,
    options: PropTypes.array,
    // { value: 'one', label: 'One' },
    //  { value: 'two', label: 'Two' },
    onChange: PropTypes.func,
}

export default withTheme(Dropdown)



// WEBPACK FOOTER //
// ./src/ui/components/Dropdown.js